import { render, staticRenderFns } from "./PUList.vue?vue&type=template&id=1a2efbb6&scoped=true"
import script from "./PUList.vue?vue&type=script&lang=js"
export * from "./PUList.vue?vue&type=script&lang=js"
import style0 from "./PUList.vue?vue&type=style&index=0&id=1a2efbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2efbb6",
  null
  
)

export default component.exports